import { useEffect, useState } from 'react';
import { DispatchProp, connect } from 'react-redux';
import { Link } from 'react-router-dom';

// actions
import { getFloatButton } from '../../redux/actions/client';

// models
import { StateModel } from '../../core/models/state.model';

interface FloatButtonProps extends DispatchProp {
	client: StateModel['client'];
}

const FloatButton = ({ client, dispatch }: FloatButtonProps) => {
	const [showButton, setShowButton] = useState(false);

	useEffect(() => {
		getFloatButton(dispatch, client);
		if (client.floatButton?.urlImage) {
			setShowButton(true);
		}
	}, [client.floatButton?.urlImage]);

	if (!showButton) {
		return null;
	}

	return (
		<Link
			className='fixed bottom-16 right-4 z-50'
			to={client.floatButton?.urlRedirect || ''}>
			<img
				src={client.floatButton?.urlImage}
				className='w-36'
				alt='Float Button'
			/>
		</Link>
	);
};

const mapStateToProps = (state: StateModel) => ({
	client: state.client,
});

export default connect(mapStateToProps)(FloatButton);
